export default function({ route, store, redirect }) {
  if(!store.getters['auth/isLogin']){
    console.log("in logout")
    return redirect('/login/')
  }
}
